import { ActionType, createReducer } from 'typesafe-actions'

import * as Actions from './actions'
import { AgreementState } from './types'

const INITIAL_STATE: AgreementState = {
  error: '',
  list: [],
  loading: false,
  request_totals: {
    total_emissions: 0,
    total_quotations: 0
  },
  sendAgreementError: '',
  sendAgreementLoading: false,
  total_results: 0
}

const reducer = createReducer<AgreementState, ActionType<typeof Actions>>(
  INITIAL_STATE
)
  .handleAction(Actions.getAgreement, state => ({
    ...state,
    error: '',
    loading: true
  }))
  .handleAction(Actions.getAgreementFailure, (state, { payload }) => ({
    ...state,
    error: payload.message,
    loading: false
  }))
  .handleAction(Actions.getAgreementSuccess, (state, { payload }) => ({
    ...state,
    list: [...payload.agreements],
    loading: false
  }))
  .handleAction(Actions.sendAgreement, state => ({
    ...state,
    sendAgreementError: '',
    sendAgreementLoading: true
  }))
  .handleAction(Actions.sendAgreementFailure, (state, { payload }) => ({
    ...state,
    sendAgreementError: payload.message,
    sendAgreementLoading: false
  }))
  .handleAction(Actions.sendAgreementSuccess, state => ({
    ...state,
    sendAgreementLoading: false
  }))

export default reducer
